import { uuidv7 } from 'uuidv7'

class Instance {
  constructor (attrs) {
    for (const key in attrs) {
      this[key] = attrs[key]
    }
  }
}

class State {
  constructor (data) {
    this.data = {}
    this.structs = {}

    for (const key in data) {
      this.data[key] = []
      this.structs[key] = data[key] || Instance
    }
  }

  findAll (model, where) {
    let instances = this.data[model]

    if (where) {
      instances = instances.filter(where)
    }

    return instances
  }

  findById (model, id) {
    return this.findAll(model, (item) => `${item.id}` === `${id}`)[0]
  }

  findOrCreateById (model, id, data) {
    let existing = this.findById(model, id)

    if (existing) {
      for (const key in data) {
        existing[key] = data[key]
      }
    } else {
      existing = this.add(model, [data])[0]
    }

    return existing
  }

  find (model, where) {
    return this.findAll(model, where)[0]
  }

  add (model, data, applyToEach) {
    const instances = data.map((instance) => {
      const Struct = this.structs[model]
      const i = new Struct(instance)

      i.id = i.id || uuidv7()

      if (typeof applyToEach === 'function') {
        applyToEach(i)
      }

      return i
    })

    this.data[model].push.apply(this.data[model], instances)

    return instances
  }

  removeAll (model, instances) {
    instances.forEach((instance) => {
      const index = this.data[model].indexOf(instance)

      this.data[model].splice(index, 1)
    })
  }

  reset () {
    for (const key in this.data) {
      this.data[key] = []
    }
  }
}

export default State
